"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NavMenuItem: true
};
exports.default = exports.NavMenuItem = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Button = require("../Buttons/Button");
var _Icon = require("../Icon/Icon");
var _Link = require("../Link/Link");
var _Overlay = require("../Overlay/Overlay");
var _Tooltip = require("../Tooltip/Tooltip");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useTypeToFocus = require("../utils/useTypeToFocus");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _isFunction = require("../utils/isFunction");
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenuItem.css") : void 0);
var _NavMenuItem2 = require("./NavMenuItem.types");
Object.keys(_NavMenuItem2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NavMenuItem2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavMenuItem2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-nav-menu-item';
const NavMenuItem = exports.NavMenuItem = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b, _c;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _d = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(NavMenuItem, props)) : props,
    {
      ariaCurrent,
      disabled,
      label,
      children,
      hideMainMenu,
      hoverToOpen,
      linkRef,
      href,
      className,
      overlayProps,
      iconProps,
      linkProps,
      buttonProps,
      submenuListProps,
      isSubMenu,
      inNavMenuBar,
      level,
      onShow,
      onHide,
      onClick,
      onKeyDown,
      inToolbarOverflow,
      tooltipMessage,
      tooltipProps
    } = _d,
    itemProps = __rest(_d, ["ariaCurrent", "disabled", "label", "children", "hideMainMenu", "hoverToOpen", "linkRef", "href", "className", "overlayProps", "iconProps", "linkProps", "buttonProps", "submenuListProps", "isSubMenu", "inNavMenuBar", "level", "onShow", "onHide", "onClick", "onKeyDown", "inToolbarOverflow", "tooltipMessage", "tooltipProps"]);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const overlayRef = (0, _react.useRef)(null);
  const internalButtonRef = (0, _react.useRef)(null);
  const internalListRef = (0, _react.useRef)(null);
  const classnames = _bind.default.bind(_NavMenuItem.default);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (children) {
      if (isOpen) {
        onShow === null || onShow === void 0 ? void 0 : onShow();
      } else if (isOpen === false) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }
    }
  }, [isOpen, children]);
  const handleClick = () => {
    if (children) {
      setIsOpen(!isOpen);
    } else {
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu();
    }
  };
  const handleMouseEnter = () => {
    if (hoverToOpen && children) {
      setIsOpen(true);
    }
  };
  const handleMouseLeave = () => {
    if (hoverToOpen && children) {
      setIsOpen(false);
    }
  };
  const handleNodeKeyDown = event => {
    if (['enter', 'space', 'right'].includes((0, _keycode.default)(event))) {
      event.preventDefault();
      handleClick();
    } else if (inNavMenuBar && (0, _keycode.default)(event) === 'left' && !isSubMenu) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  const handleLinkKeyDown = event => {
    var _a, _b;
    if (['enter', 'space'].includes((0, _keycode.default)(event))) {
      (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
    } else if (inNavMenuBar && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'left' && !isSubMenu)) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  const handleDisabledKeyDown = event => {
    if (['enter', 'space'].includes((0, _keycode.default)(event))) {
      return;
    }
    if (inNavMenuBar && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'left' && !isSubMenu)) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  const handleSubMenuKeyDown = event => {
    var _a, _b;
    if (isOpen && (0, _keycode.default)(event) === 'left') {
      event.stopPropagation();
      setIsOpen(false);
      (_b = (_a = internalButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  };
  const {
    handleTypeToFocus
  } = (0, _useTypeToFocus.useTypeToFocus)({
    focusCandidates: Array.from(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
    keyStrokeTimeout: 50,
    focusMatchingItem: _navMenuUtils.focusMatchingItem
  });
  const icon = /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({
    ariaHidden: true,
    iconName: "arrow-2-e",
    size: "xs-plus",
    forceSize: "xs-plus",
    "data-level": level
  }, iconProps, {
    className: classnames(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, {
      [`${CSS_BLOCK}__icon--disabled`]: disabled,
      [`${CSS_BLOCK}__overflow-menu-icon`]: inToolbarOverflow
    }),
    "data-nui-widgets": "menuitem-node"
  }));
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, itemProps, {
      ref: ref,
      role: "menuitem",
      "aria-disabled": true,
      tabIndex: 0,
      "data-nui-widgets": "menuitem-leaf",
      onKeyDown: handleDisabledKeyDown,
      className: classnames(className, `${CSS_BLOCK}--disabled`, {
        [`${CSS_BLOCK}__link--sub`]: !!children
      })
    }), label, children && icon);
  }
  const passChildProps = child => {
    if (child.displayName === 'NavMenuItem') {
      const navMenuItemProps = {
        isSubMenu: true,
        hideMainMenu,
        inNavMenuBar,
        hoverToOpen,
        inToolbarOverflow,
        level: (level || 0) + 1
      };
      return navMenuItemProps;
    }
    return {};
  };
  const buttonTarget = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    type: "link"
  }, buttonProps, {
    role: "menuitem",
    "data-level": level,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-current": !!ariaCurrent || undefined,
    "data-nui-widgets": "menuitem-node",
    disabled: disabled,
    className: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, `${CSS_BLOCK}__link`, `${CSS_BLOCK}__link--sub`, {
      [`${CSS_BLOCK}__overlay-link`]: (0, _isFunction.isFunction)(hideMainMenu),
      [`${CSS_BLOCK}__link--open`]: isOpen,
      [`${CSS_BLOCK}__link--current`]: !!ariaCurrent,
      [`${CSS_BLOCK}__toolbar-overflow-button`]: inToolbarOverflow
    }),
    innerProps: Object.assign(Object.assign({}, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps), {
      className: classnames((_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerProps) === null || _b === void 0 ? void 0 : _b.className, `${CSS_BLOCK}__link-inner`)
    }),
    innerTextClasses: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerTextClasses, `${CSS_BLOCK}__link-text`),
    onClick: (0, _chainFunction.default)(handleClick, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleNodeKeyDown, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onKeyDown),
    ref: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.ref) ? (0, _reactMergeRefs.default)([buttonProps.ref, internalButtonRef]) : internalButtonRef
  }), label, icon);
  const wrappedButton = tooltipMessage && !inToolbarOverflow && !isOpen ? (/*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, Object.assign({}, tooltipProps, {
    message: tooltipMessage
  }), buttonTarget)) : buttonTarget;
  return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, itemProps, {
    role: "none",
    ref: ref,
    className: classnames(className, `${CSS_BLOCK}__wrapper`),
    onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, itemProps === null || itemProps === void 0 ? void 0 : itemProps.onMouseEnter),
    onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, itemProps === null || itemProps === void 0 ? void 0 : itemProps.onMouseLeave),
    onClick: onClick,
    onKeyDown: onKeyDown
  }), !children ? (/*#__PURE__*/_react.default.createElement(_Link.Link, Object.assign({}, linkProps, {
    role: "menuitem",
    tabIndex: 0,
    matchButtonHeight: true,
    className: classnames(_constants.CSS_PREFIX, linkProps === null || linkProps === void 0 ? void 0 : linkProps.className, `${CSS_BLOCK}__link`, {
      [`${CSS_BLOCK}__overlay-link`]: (0, _isFunction.isFunction)(hideMainMenu),
      [`${CSS_BLOCK}__link--current`]: !!ariaCurrent,
      [`${CSS_BLOCK}__toolbar-overflow-link`]: inToolbarOverflow
    }),
    innerTextClasses: classnames(linkProps === null || linkProps === void 0 ? void 0 : linkProps.innerTextClasses, `${CSS_BLOCK}__link-text`),
    href: href,
    onClick: (0, _chainFunction.default)(handleClick, linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleLinkKeyDown, linkProps === null || linkProps === void 0 ? void 0 : linkProps.onKeyDown),
    "aria-current": ariaCurrent,
    "data-nui-widgets": "menuitem-leaf",
    ref: linkRef
  }), label)) : (/*#__PURE__*/_react.default.createElement(_Overlay.Overlay, Object.assign({
    offset: -5,
    popperPlacement: ['right-start', 'right', 'left-start', 'left', 'bottom-end', 'bottom']
  }, overlayProps, {
    onShow: () => setIsOpen(true),
    onHide: () => {
      setIsOpen(false);
    },
    ref: overlayRef,
    onClickOutside: event => (0, _navMenuUtils.handleOutsideClick)(event, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside, hideMainMenu, level),
    popperProps: Object.assign(Object.assign({
      role: 'presentation',
      'data-overflow-flyout': 'true',
      'data-nui-widgets': 'menu-overlay'
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      onKeyDown: (0, _chainFunction.default)(handleSubMenuKeyDown, handleTypeToFocus, (_c = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _c === void 0 ? void 0 : _c.onKeyDown)
    }),
    targetClassName: classnames(`${CSS_BLOCK}__overlay`),
    targetComponent: wrappedButton,
    show: isOpen,
    focusManagerProps: {
      nextKeyCode: _keycode.default.codes.down,
      previousKeyCode: _keycode.default.codes.up,
      trapWithTabbing: true,
      onlyContainedEvents: true,
      useHomeAndEndKeys: true
    }
  }), /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, submenuListProps, {
    role: "menu",
    className: classnames(CSS_BLOCK, submenuListProps === null || submenuListProps === void 0 ? void 0 : submenuListProps.className),
    ref: (submenuListProps === null || submenuListProps === void 0 ? void 0 : submenuListProps.ref) ? (0, _reactMergeRefs.default)([submenuListProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children)))));
});
NavMenuItem.displayName = 'NavMenuItem';
var _default = exports.default = NavMenuItem;